
  import createMeisterIcons from '../src/createMeisterIcons';

  const Meter = createMeisterIcons("meter", [["path",{"fill":"currentColor","d":"M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12","key":"d53466864ceb95ac8010b5419754b5d2b8b27d59","fillRule":"evenodd","clipRule":"evenodd"}],["path",{"fill":"currentColor","d":"M15.53 8.47a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l3-3a.75.75 0 0 1 1.06 0","key":"14eb7f5fd6e62519fdcfea8e893f6bdfc4f8b17e","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Meter
  